import React from 'react';

import { Box, Grid, Typography } from '@mui/material';

interface SectionHeaderProps {
    title: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
    return (
        <Grid
            item
            xs={12}
            sx={{
                borderBottom: '1px solid #F18F34',
                marginBottom: '24px',
            }}
        >
            <Box display="flex" flexDirection="column" gap="8px">
                <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>{title}</Typography>
            </Box>
        </Grid>
    );
};
